// ABOUTME: Route for /share/:shareId — read-only viewer for a shared conversation.

import { SharedConversationPage } from "@/components/SharedConversationPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/share/$shareId")({
  component: SharedConversationPage,
});
